import React, { useContext, useEffect, useState } from 'react'
import LoginContext from "../../Context/Logincontext"
import Nav1 from '../../Component/Nav/Nav1'
import { NavLink } from 'react-router-dom'
import "../../styles/AddProduct.css"
import '../../styles/AddClient.css'
import '../../styles/AddCompositeProduct.css'
import Swal from 'sweetalert2'
import { ImExit } from 'react-icons/im'
import CloseButton from '../../Component/CloseButton'
import LogoComponent from '../../Component/LogoComponent'
import { urlApiServer } from '../../Config/Config'

let splitImg = []

const EditProduct = ({ id, onClose }) => {
    const urlputCompositeproduct = urlApiServer + "editproduct";
    const urlgetCompositeproductById = urlApiServer + "getProductById";

    const [name, setName] = useState('')
    const [laborPrice, setLaboralPrice] = useState(null);
    const [unit, setUnit] = useState(null);
    const [vat, setVat] = useState(null);
    const [totalPrice, setTotalPrice] = useState('');
    const { infoUser, setInfoUser } = useContext(LoginContext)
    const [oldConfig, setOldConfig] = useState("")
    const [logo, setLogo] = useState("")
    const [utility, setUtility] = useState('');

    useEffect(() => {
        (async function () {
            const InicioHeaders = new Headers();
            InicioHeaders.append("Content-Type", "application/json")
            InicioHeaders.append("id", id);
            InicioHeaders.append("company", infoUser.company);

            const requesoption = {
                method: 'GET',
                headers: InicioHeaders,
                redirect: 'follow'
            }

            await fetch(urlgetCompositeproductById, requesoption)
                .then(response => response.json())
                .then(quotesResponse => {
                    console.log("quotesResponse: ", quotesResponse[0]);

                    const productData = quotesResponse[0];
                    if (productData) {
                        setName(productData.producto);
                        setLaboralPrice(productData.precioitem)
                        setUnit(productData.unit)
                        setVat(productData.iva)
                        setUtility(productData.utility)

                        // Calcular el precio total usando la función existente
                        calculateTotalPrice();

                    }
                })
        })()
    }, [id, infoUser.company])

    useEffect(() => {
        if (oldConfig) {
            const foundConfig = oldConfig.find(obj => obj.empresa === infoUser.company);
            if (foundConfig) {
                const { logo } = foundConfig;
                setLogo(logo);
            }
        }
    }, [oldConfig, infoUser])

    if (logo) {
        splitImg = logo.split("|")
    }

    async function handleName(e) {
        const name = e.target.value.replace(/[^A-Z a-z0-9.]/g, "");
        setName(name)
    }

    async function handleLaborPrice(e) {
        const laborPrice = e.target.value.replace(/[^0-9-._]/g, '');
        setLaboralPrice(laborPrice);
        calculateTotalPrice();
    }

    async function handleUnit(e) {
        const unit = e.target.value;
        setUnit(unit)
    }

    async function handleVat(e) {
        const vat = e.target.value;
        setVat(vat);
        calculateTotalPrice();
    }

    async function handleUtility(e) {
        const utility = e.target.value.replace(/[^0-9.]/g, '');
        setUtility(utility);
        calculateTotalPrice(inventoryFields);
    }

    async function uploadInventory() {
        const data = JSON.stringify({
            empresa: infoUser.company,
            Id: id,
            product: name,
            material: null,
            long: null,
            caliber: null,
            price: laborPrice,
            iva: vat,
            modeljson: null,
            Model: null,
            image: null,
            ancho: null,
            cantidad: 1,
            unit: unit,
            utility: utility
        })
        const registerHeaders = new Headers();
        registerHeaders.append("Content-Type", "application/json")

        const requesoption = {
            method: 'PUT',
            headers: registerHeaders,
            body: data,
            redirect: 'follow'
        }

        await fetch(urlputCompositeproduct, requesoption).then(response => response.json())
            .then(dataResponse => {
                if (dataResponse.msj !== "Actualizado producto") {
                    Swal.fire({
                        icon: 'error',
                        text: 'Ha ocurrido un problema al intentar editar un producto.',
                        confirmButtonText: 'Aceptar',
                    }).then((result) => {
                    })
                } else {
                    Swal.fire({
                        icon: 'success',
                        title: '¡Hecho!',
                        text: 'Haz actualizado este dato.',
                        confirmButtonText: 'Aceptar',
                    }).then((result) => {
                        onClose(); // Ejecuta la función
                    })
                }
            })
    }

    const calculateTotalPrice = () => {

        // 2. Obtener valores base
        const labor = parseFloat(laborPrice) || 0;
        const vatPercentage = parseFloat(vat) || 0;
        const vatUtility = parseFloat(utility) || 0;

        // 3. Calcular subtotal (mano de obra + materiales)
        const subtotal = labor;

        // 4. Calcular total con cantidad de productos y IVA
        const totalWithQuantity = subtotal;
        const totalWithVat = totalWithQuantity * (1 + vatPercentage / 100) * (1 + vatUtility / 100);

        setTotalPrice(totalWithVat.toFixed(2));
    };

    useEffect(() => {
        calculateTotalPrice();
    }, [laborPrice, vat, utility]);


    return (
        <>
            {(infoUser.login === true) ? (
                (infoUser.role === 'SuperUsuario') ? (window.location.href = './Crear_Empresa') : (
                    <>
                        <div className="containerHeardANDTable">
                            <div className="HeardANDFilter">
                                <LogoComponent />
                                <div className='containerButtonAdd'>
                                    <div className="navigationContainer">
                                        <div className="pageTitle">EDITAR PRODUCTO COMPUESTO</div>
                                    </div>
                                </div>
                                <div className='closeIntContainer'>
                                    <CloseButton />
                                </div>
                            </div>
                        </div>
                        <div id='overallContainer' className='overallContainer'>
                            <Nav1 />
                            <div className='drawerFormAddCuotes'>
                                <form className='ContainerClient'>
                                    <div className='containerInfoAdd'>
                                        <div className='infoOneEdit'>
                                            <p className='personalInformationEdit'>EDITAR PRODUCTO COMPUESTO</p>
                                            <p className='personalInformationEdit'>Producto</p>
                                            <div className='containerNameClient'>
                                                <div className="inputClientContainer">
                                                    <input
                                                        type="text"
                                                        value={name}
                                                        name="Name"
                                                        id="Name"
                                                        onChange={handleName}
                                                        className="inputCLient"
                                                        placeholder=" "
                                                    />
                                                    <label htmlFor="name">Nombre del producto <em className='Obligatory'>*</em> </label>
                                                </div>
                                                <div className="inputClientContainer">
                                                    <input
                                                        type="number"
                                                        value={laborPrice}
                                                        name="laborPrice"
                                                        id="laborPrice"
                                                        onChange={handleLaborPrice}
                                                        className="inputCLient"
                                                        placeholder=" "
                                                    />
                                                    <label htmlFor="name">Precio de mano de obra <em className='Obligatory'>*</em> </label>
                                                </div>
                                            </div>
                                            <div className='containerNameClient'>
                                                <div className="inputClientContainer">
                                                    <select
                                                        type="text"
                                                        value={unit}
                                                        name="unit"
                                                        id="unit"
                                                        onChange={handleUnit}
                                                        className="inputCLient"
                                                        placeholder=" "
                                                    >
                                                        <option value="">Unidad: </option>
                                                        <option value="U">U (Unidad)</option>
                                                        <option value="M">M (Metros)</option>
                                                        <option value="M2">M2 (Metros Cuadrados)</option>
                                                        <option value="C">C (Centimetros)</option>
                                                        <option value="P">P (Pulgadas)</option>
                                                        <option value="K">K (Kilogramos)</option>
                                                        <option value="G">G (Gramos)</option>
                                                        <option value="L">L (Libras)</option>
                                                        <option value="LT">LT (Litros)</option>
                                                        <option value="R">R (Radianes)</option>
                                                        <option value="R">S (Segundos)</option>
                                                        <option value="H">H (Horas)</option>
                                                        <option value="Dia/s">Dias</option>
                                                        <option value="Mes/es">Meses</option>
                                                        <option value="Año/s">Años</option>
                                                    </select>
                                                </div>
                                                <div className="inputClientContainer">
                                                    <select
                                                        type="text"
                                                        value={vat}
                                                        name="vat"
                                                        id="vat"
                                                        onChange={handleVat}
                                                        className="inputCLient"
                                                        placeholder=" "
                                                    >
                                                        <option value="">Iva: </option>
                                                        <option value="0">0%</option>
                                                        <option value="5">5%</option>
                                                        <option value="16">16%</option>
                                                        <option value="19">19%</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className='containerNameClient'>
                                                <div className='containerNameClient'>
                                                    <div className="inputClientContainer">
                                                        <input
                                                            type="number"
                                                            value={utility}
                                                            name="utility"
                                                            id="utility"
                                                            placeholder=" "
                                                            className="inputCLient"
                                                            onChange={handleUtility}
                                                        />
                                                        <label htmlFor="utility">Utilidad (%)</label>
                                                    </div>
                                                    <div className="inputClientContainer">
                                                        <input
                                                            type="number"
                                                            value={totalPrice}
                                                            name="totalPrice"
                                                            id="totalPrice"
                                                            placeholder=" "
                                                            className="inputCLient"
                                                            readOnly
                                                        />
                                                        <label htmlFor="name">
                                                            Precio total
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="buttonContainerAddClient">
                                                <NavLink className='Textregister' onClick={onClose}><button className="button neon_Effect"><p>Atras</p></button></NavLink>
                                                <NavLink onClick={uploadInventory} className='Textregister'><button className="button neon_Effect"><p>Actualizar</p></button></NavLink>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </>
                )
            ) : (window.location.href = './Iniciar_Sesión')}
        </>
    )
}

export default EditProduct